import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const img = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);

export const CATEGORIES = [
  { slug: "peternakan", label: "Peternakan" },
  { slug: "edukasi-sapi", label: "Edukasi Sapi" },
  { slug: "fakta-unik", label: "Fakta Unik" },
];
export const BREEDS = ["Limousin", "Simmental", "Bali"];
export const STATUSES = ["Tersedia", "Terpesan", "Terjual"];

export const catLabel = (s) => CATEGORIES.find((c) => c.slug === s)?.label || s;
export const fmtDate = (d) =>
  new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
export const waLink = (num, text = "") =>
  `https://wa.me/${(num || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.url;
};

export const useGet = (key, path, params) =>
  useQuery({
    queryKey: [key, params, path],
    queryFn: async () => (await api.get(path, { params })).data,
    retry: (n, e) => e?.response?.status !== 404 && n < 2,
  });

export const useSettings = () => useGet("settings", "/settings");

export const useAction = (keys) => {
  const qc = useQueryClient();
  return async (fn, okMsg) => {
    try {
      const res = await fn();
      if (okMsg) toast.success(okMsg);
      keys.forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
      return res || true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  };
};
